module.exports = __webpack_public_path__ + "b530f920.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginElements/img/spirotech_logo_tran.png
// module id = 1444
// module chunks = 0 9